<template :class="$style.root">
  <p :class="$style[`root-title`]">PST FAQ</p>
  <div :class="$style.divider" />
  <div :class="$style.faq">
    <div :class="$style.content">
      <p :class="$style.title">{{ $t("timezone.faqPST") }}</p>
      <p :class="$style.text">
        {{ $t("timezone.faqPSTDesc") }}
      </p>
    </div>
    <div :class="$style.content">
      <p :class="$style.title">{{ $t("timezone.faqPSTLive") }}</p>
      <p :class="$style.text">
        {{ $t("timezone.faqPSTLiveDesc") }}
      </p>
    </div>
    <div :class="$style.content">
      <p :class="$style.title">{{ $t("timezone.faqPSTTime") }}</p>
      <p :class="$style.text">
        {{ $t("timezone.faqPSTTimeDesc") }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  &-title {
    @apply font-light text-[30px] sm:text-[47px] leading-[55px] ltr:text-left rtl:text-right rtl:sm:text-center sm:text-center text-black;
  }
}
.divider {
  @apply hidden sm:block opacity-20 w-full border-[1px] border-solid border-black mt-[26px] mb-[50px];
}
.faq {
  @apply flex items-center justify-between flex-col gap-[23px] sm:gap-[46px] w-full;
}
.content {
  @apply flex items-start justify-between flex-col lg:flex-row;
}
.title {
  @apply font-semibold text-[24px] sm:text-[30px] leading-[45px] w-full lg:w-[25%];
}
.text {
  @apply font-normal text-[16px] sm:text-[24px] leading-[150%] opacity-70 w-full lg:w-[56%];
}
</style>
